export const leadConversionStyles = {
    mainContainer: {
        padding: '16px',
        height: 'calc(100vh - 32px)',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        backgroundColor: '#1a1a1a',
        color: 'white',
    },

    filterPaper: {
        p: 1.5,
        backgroundColor: '#2d2d2d',
        backdropFilter: 'blur(10px)',
        border: '1px solid #404040',
        flexShrink: 0,
    },
    filterContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: 1,
        alignItems: 'center',
        borderRadius: '5px',
    },
    filterBox: {
        flex: { xs: '1 1 100%', md: '0 0 calc(25% - 8px)' },
        minWidth: '150px',
    },
    searchButtonBox: {
        flex: { xs: '1 1 100%', md: '0 0 auto' },
        minWidth: '100px',
    },
    datePicker: {
        backgroundColor: '#404040',
        '& .MuiInputLabel-root': {
            color: '#e0e0e0',
            '&.Mui-focused': { color: '#2196F3' },
        },
        '& .MuiInputBase-input': { color: 'white' },
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#606060',
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#2196F3',
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#2196F3',
        },
        '& .MuiSvgIcon-root': {
            color: '#e0e0e0',
        },
    },
    searchButton: {
        backgroundColor: '#2196F3',
        '&:hover': {
            backgroundColor: '#1976D2',
        },
        '&:disabled': {
            backgroundColor: '#404040',
            color: '#666',
        },
    },
    tablePaper: {
        flex: 1,
        minHeight: 0,
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        marginTop: 1,
    },
    tableContainer: {
        flex: 1,
        minHeight: 0,
        marginTop: 1,
        backdropFilter: 'blur(10px)',
        border: '1px solid #404040',
        borderRadius: '10px',
        display: 'flex',
        flexDirection: 'column',
        // overflow: 'hidden',
        overflow: 'auto',
        '& .MuiTableCell-root': {
            color: 'white',
            borderBottom: '1px solid #404040',
            padding: '8px 12px',
        },
    },
    tableHead: {
        backgroundColor: '#1a1a1a',
        '& .MuiTableCell-head': {
            fontWeight: 'bold',
            color: 'white',
            position: 'sticky',
            top: 0,
            backgroundColor: '#1a1a1a',
            zIndex: 1,
            padding: '8px 12px',
        },
    },

    tableRow: {
        backgroundColor: '#252525',
        '&:hover': {
            backgroundColor: '#353535',
        },
    },

    tableCell:{ 
        color: 'white', 
        fontWeight: 'bold',
        borderRight: '1px solid #404040',
        textTransform: 'uppercase',
        padding: '8px 12px',
    },
};